<template>
    <div class="single-product__size-guide" data-index="1">
        <div class="single-product__size-guide-container">
            <a class="single-product__size-guide--btn" @click="show_guide__popup">Ring Size Guide</a><img alt="alert-info" src="/single-product/alert-info-icon.webp">
        </div>
        <div class="size-guide__popup" ref="popupRef" id="size-guide__popup-1" :class="open ? 'active' : ''">
            <div class="size-guide__content" ref="contentRef">
                <h4 class="size-guide__heading">Ring Size Guide</h4>
                <div class="size-guide__tab-panel">
                    <span data-tab="size-chart" class="size-guide__tab size-guide__tab--size-chart" :class="{ 'active-tab': currentTab === 'size' }" @click="handleRingTab('size')">Size Chart</span>
                    <span data-tab="guide" class="size-guide__tab size-guide__tab--guide" :class="{ 'active-tab': currentTab === 'measurement' }" @click="handleRingTab('measurement')">Measurement Guide</span>
                </div>
                <div class="size-guide__tab-content size-guide__tab-content--size-chart" :class="{ 'active-tab': currentTab === 'size' }">
                    <div class="size-guide__size-chart">
                        <table>
                            <tbody>
                                <tr v-for="(row, rowIndex) in sizeChart" :key="rowIndex">
                                    <td v-for="(cell, cellIndex) in row" :key="cellIndex">
                                    {{ cell }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="size-guide__size-chart--text">
                        <!-- <p>This bracelet size guide provides a general guideline, and personal fit preference may affect your final choice. For reference, an average Asian woman typically wears a size 16.0cm bracelet, while an average man might wear 17.5cm.</p> -->
                    </div>
                </div>
                <div class="size-guide__tab-content size-guide__tab-content--guide" :class="{ 'active-tab': currentTab === 'measurement' }">
                    <div class="ring-size__tab-panel">
                        <span data-tab="find-ring-size" class="ring-size__tab" :class="{ 'active': currentTabChild === 'find' }" @click="handleChildTab('find')">Find Ring Size</span>
                        <span data-tab="free-size-ring" class="ring-size__tab" :class="{ 'active': currentTabChild === 'free' }" @click="handleChildTab('free')">Free Size Ring</span>
                    </div>
                    <div class="ring-size__tab-content ring-size__tab-content--find-ring-size alt-ring-size" :class="{ 'active': currentTabChild === 'find' }">
                        <h4>How Do I Find My Ring Size?</h4>
                        <video class="size-guide__video" autoplay muted playsinline loop :src="`${baseUrl}api/wp-content/uploads/2024/07/Ring-Size-Measurement-Kit_30mb.mp4`" :data-original_src="`${baseUrl}wp-content/uploads/2024/07/Ring-Size-Measurement-Kit_30mb.mp4`"></video>
                        <div class="size-guide__method-title"><span>Method 1:</span><span>Measure using a strip of paper or wide thread</span></div>
                        <img src="/single-product/ring-size-guide-1.webp" data-original_src="/single-product/ring-size-guide-1.webp" class="size-guide__image" alt="ring-size-guide-img">
                        <div class="size-guide__step">
                            <h4>Step 1</h4>
                            <span>Measure your finger by wrapping a strip of paper or wide thread around it, leaving enough space to slide the ring over your knuckle.</span>
                        </div>
                        <div class="size-guide__step">
                            <h4>Step 2</h4>
                            <span>Mark the place where the paper strip meets and measure the length by using a ruler.</span>
                        </div>
                        <div class="size-guide__step">
                            <h4>Step 3</h4>
                            <span>Cross reference the measurement to the ring size chart and find the closest measurement.</span>
                        </div>
                        <div class="size-guide__method-title"><span>Method 2:</span><span>Measure using a ruler</span></div>
                        <img src="/single-product/ring-size-guide-2.webp" data-original_src="/single-product/ring-size-guide-2.webp" class="size-guide__image" alt="ring-size-guide-img">
                        <div class="size-guide__step">
                            <h4>Step 1</h4>
                            <span>Measure one of your own rings using a ruler. Lay the ring on a flat surface and place a ruler on top of the ring.</span>
                        </div>
                        <div class="size-guide__step">
                            <h4>Step 2</h4>
                            <span>Measure the internal diameter of the ring.</span>
                        </div>
                        <div class="size-guide__step">
                            <h4>Step 3</h4>
                            <span>Cross refer the measurement to the ring size chart and find the closest measurement.</span>
                        </div>
                        <div class="size-guide__content-footer" style="display: flex;">
                            <div class="">
                                <div class="size-guide__content-footer-icon">
                                    <img src="/single-product/size-guide-footer-icon.webp" data-original_src="/single-product/size-guide-footer-icon.webp" class="size-guide__image" alt="icon img">
                                </div>
                                <div class="size-guide__description">
                                    <h4>In need of further help with finding your exact ring size match?</h4>
                                    <span>Download our printable Ring Size Chart to see how to accurately measure your ring finger.</span>
                                </div>
                            </div>
                            <a v-if="file_link" target="_blank" :href="file_link" class="size-guide__download">
                            <span>Ring Size Chart</span>
                            <img src="/single-product/download-icon.webp" alt="download-icon">
                            </a>
                        </div>
                    </div>
                    <div class="ring-size__tab-content ring-size__tab-content--free-size-ring alt-ring-size" :class="{ 'active': currentTabChild === 'free' }">
                        <video class="size-guide__video" autoplay muted playsinline loop data-original_src="https://www.skjewellery.com.my/api/wp-content/uploads/2024/07/Free-Size-Gold-Ring_30mb.mp4" src="https://www.skjewellery.com.my/api/wp-content/uploads/2024/07/Free-Size-Gold-Ring_30mb.mp4"></video>
                        <h4>What Is A Free Size Ring?</h4>
                        <p>Free size ring is designed for ease and flexibility, adjusting to fit any finger comfortably. Made from 999 pure gold, the ring can be easily widened or tightened by gently manipulating the open ends. The standard base ring size is HK 12.0, and can be adjusted from ring size HK 8.0 to HK 17.0.</p>
                        <img src="/single-product/ring-size-free-1.webp" data-original_src="/single-product/ring-size-free-1.webp" class="size-guide__image" alt="ring-size-guide-img">
                        <div class="size-guide__step">
                            <h4>Step 1</h4>
                            <span>Put the ring onto your desired finger.</span>
                        </div>
                        <img src="/single-product/ring-size-free-2.webp" data-original_src="/single-product/ring-size-free-2.webp" class="size-guide__image" alt="ring-size-guide-img">
                        <div class="size-guide__step">
                            <h4>Step 2</h4>
                            <span><span>TIGHTEN</span>Using your fingers, slowly and gently squeeze the band inwards to tighten.</span>
                        </div>
                        <img src="/single-product/ring-size-free-3.webp" data-original_src="/single-product/ring-size-free-3.webp" class="size-guide__image" alt="ring-size-guide-img">
                        <div class="size-guide__step">
                            <h4>Step 3</h4>
                            <span><span>LOOSEN</span>Using both hands, grip on both sides of the band, slowly and gently pull outwards to loosen.</span>
                        </div>
                    </div>
                </div>
                <div class="size-guide__footer">
                    <a @click="close_guide__popup" class="size-guide__close"><span>Continue Shopping</span></a>
                </div>
                <span class="size-guide__close-btn" @click="close_guide__popup">
                    <svg class="icon_close" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M6.4 19L5 17.6l5.6-5.6L5 6.4L6.4 5l5.6 5.6L17.6 5L19 6.4L13.4 12l5.6 5.6l-1.4 1.4l-5.6-5.6z"/></svg>
                </span>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import "@/assets/scss/components/product/_sizeguide.scss";
</style>

<script setup lang="ts">
const currentTab = ref('size');
const currentTabChild = ref('find');
    const { $ajax, $file } = useNuxtApp();
    const userStore = useUserStore();
    const runtimeConfig = useRuntimeConfig();
    const baseUrl = runtimeConfig.public.BASE_URL;
    const sizeChart = ref([
        ['Circumference (MM)', 'Inside Diameter (MM)', 'HK', 'US'],
        ["XXX", "XXX", "Free size", "Free Size"],
        ["43.5", "13.8", "5", '2¾'],
        ["44.1", "14.1", "6", "3"],
        ["45.4", "14.5", "7", "3½"],
        ["46.7", "14.9", "8", "3¾"],
        ["48", "15.3", "9", "4¼"],
        ["48.8", "15.5", "10", "4¾"],
        ["50", "15.9", "11", "5¼"],
        ["51.2", "16.3", "12", "5½"],
        ["52.5", "16.7", "13", "6"],
        ["53.2", "16.9", "14", "6½"],
        ["54.8", "17.5", "15", "7"],
        ["55.8", "17.8", "16", "7½"],
        ["56.5", "18", "17", "7¾"],
        ["57.7", "18.4", "18", "8¼"],
        ["58.7", "18.7", "19", "8¾"],
        ["60", "19.1", "20", "9"],
        ["61", "19.4", "21", "9½"],
        ["62.3", "19.8", "22", "10"],
        ["62.9", "20", "23", "10¼"],
        ["64.2", "20.4", "24", "10¾"],
        ["65.8", "20.9", "25", "11¼"],
        ["66.2", "21.1", "26", "11½"],
        ["67.5", "21.5", "27", "12"],
        ["68.8", "21.9", "28", "12½"],
        ["70.2", "22.3", "29", "12¾"],
        ["71", "22.6", "30", "13¼"]
    ]);
    const file_link=ref()
    const getFile = async () => {
        try {
            const response = await $ajax.get('wp-json/skj/v1/download-size-chart');

            console.log(response)
            if(response) {
                file_link.value = response.download_url
            }
        } catch (error) {
            console.log('Failed. Retrying...');
        }

    }
    getFile();
    const open = ref(false)

    const popupRef = ref<HTMLElement | null>(null);
    const contentRef = ref<HTMLElement | null>(null);

    const handleClickOutside = (event: MouseEvent) => {
        if (contentRef.value && !contentRef.value.contains(event.target as Node)) {
            close_guide__popup();
        }
    };
    
    const show_guide__popup = () =>{
        currentTab.value = 'size';
        currentTabChild.value = 'find';
        open.value = true,
        document.body.style.overflowY = 'hidden';
        setTimeout(() => {
            document.addEventListener('click', handleClickOutside);
        }, 500);
    }
    const close_guide__popup = () =>{
        open.value = false,
        document.body.style.overflowY = 'scroll';
        document.removeEventListener('click', handleClickOutside);
    }

    const handleRingTab = (tab: string) => {
        currentTab.value = tab;
    }

    const handleChildTab = (tab: string) => {
        currentTabChild.value = tab;
    }

    onMounted(() => {
        getFile();
    })
</script>